import axios from "axios";
import { SEARCH_JOB_POSTS_URL } from "../utils";

//TODO use proper type
export const searchJobPosts = async (filter: any) => {
  return axios.post(SEARCH_JOB_POSTS_URL, filter);
};
